import { Component, OnInit, Input } from '@angular/core';
import { of, Observable } from 'rxjs';
import { ApiV1Job, DashboardFeedItemTopJobs } from '@bluecrew/crew-member-backend-angular-client';
import { NavController } from '@ionic/angular';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';

@Component({
  selector: 'app-top-jobs',
  templateUrl: './top-jobs.component.html',
  styleUrls: ['./top-jobs.component.scss'],
})
export class TopJobsComponent implements OnInit {
  $topJobs: Observable<ApiV1Job[]>;

  @Input()
  get feedItem(): DashboardFeedItemTopJobs { return this._feedItem; }
  set feedItem(feedItem: DashboardFeedItemTopJobs) {
    this.$topJobs = of(feedItem.topJobs);
  }
  private _feedItem: DashboardFeedItemTopJobs;

  constructor(
    private readonly navCtrl: NavController,
  ) { }

  ngOnInit() {}

  async onMoreJobsClick() {
    await this.navCtrl.navigateForward(AppRoutingUtil.BROWSE_JOBS);
  }
}
